import React from 'react'

function Math() {
  return (
    <div>Math</div>
  )
}

export default Math